import { template } from "radash";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customTemplate = (str: string, data: Record<string, any>) => {
  return template(str, data, /{(.+?)}/g);
};

export default customTemplate;
